import { Link, Typography, TypographyProps } from '@mui/material';

export default function Copyright(props: TypographyProps) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        DriveOn Subscriptions
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}
